module.exports = __webpack_public_path__ + "img/IMG_20131226_161631.f984a264.jpg";